// extracted by mini-css-extract-plugin
export default {"message":"styles_message__JxW4N"};